<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Solicitud de Registro Aprobada"
          directory="Información"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <a href="/approved/oec" class="btn btn-primary">Volver</a>
        </div>
      </div>
    </div>

    <div class="card card-with-shadow border-0 mb-primary">
      <div class="card-body">
        <form
          ref="form"
          class="mb-0"
          data-url="/approved/oec"
          enctype="multipart/form-data"
          :class="{ 'loading-opacity': preloader }"
        >
          <fieldset class="form-group">
            <div class="card card-with-shadow border-0 mb-primary">
              <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">Información de la Compañia</h5>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("company_name") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.company_name"
                    :read-only="true"
                    :placeholder="$t('type_company_name')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("social_reason") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.social_reason"
                    :read-only="true"
                    :placeholder="$t('type_social_reason')"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("ruc") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.ruc"
                    :min-length="0"
                    :max-length="20"
                    :read-only="true"
                    v-on:keypress="isNumber"
                    :placeholder="$t('type_ruc')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("kind_society") }}</label>
                  <app-input
                    class="col-sm-8"
                    type="radio-buttons"
                    :disabled="true"
                    v-model="inputs.society_type"
                    :list="kindOfSocietyLists"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("email") }}</label>
                  <app-input
                    type="email"
                    v-model="inputs.email"
                    :read-only="true"
                    :placeholder="$t('type_email')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("company_address") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.company_address"
                    :read-only="true"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>{{ $t("country") }}</label>
                  <app-input
                    type="select"
                    v-model="inputs.country_id"
                    :disabled="true"
                    :list="countryList"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <div v-if="inputs.province_id">
                    <label>{{ $t("province") }}</label>
                    <app-input
                      type="select"
                      v-model="inputs.province_id"
                      :disabled="true"
                      :list="provinceList"
                    />
                  </div>
                  <div v-if="!inputs.province_id">
                    <label>{{ $t("Ciudad") }}</label>
                    <app-input
                      type="text"
                      v-model="inputs.city"
                      :disabled="true"
                      :placeholder="$t('Ingrese Ciudad')"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <div v-if="inputs.canton_id">
                    <label>{{ $t("canton") }}</label>
                    <app-input
                      type="select"
                      v-model="inputs.canton_id"
                      :disabled="true"
                      :list="cantonList"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("phone") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.phone"
                    :disabled="true"
                    :placeholder="$t('type_phone')"
                  />
                </div>
              </div>
              <div class="col-md-6" v-if="inputs.phone_extension">
                <div class="form-group">
                  <label>{{ $t("Extensión") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.phone_extension"
                    :required="false"
                    :disabled="true"
                    :placeholder="$t('Extensión telefónica')"
                  />
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset class="form-group">
            <div class="card card-with-shadow border-0 mb-primary">
              <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t("legal_rep") }}</h5>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("Nombre de Usuario") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.username"
                    :read-only="true"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("Fecha de Registro") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.created_at"
                    :read-only="true"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("first_name") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.first_name"
                    :read-only="true"
                    :placeholder="$t('type_names')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("last_name") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.last_name"
                    :read-only="true"
                    :placeholder="$t('type_lastname')"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("taxid_legal_rep") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.taxid_legal_rep"
                    :min-length="10"
                    :max-length="20"
                    v-on:keypress="isNumber"
                    :read-only="true"
                    :placeholder="$t('type_ci')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("email") }}</label>
                  <app-input
                    type="email"
                    v-model="inputs.email_legal_rep"
                    :read-only="true"
                    :placeholder="$t('type_email')"
                  />
                </div>
              </div>
            </div>
          </fieldset>

          <div class="card card-with-shadow border-0 mb-primary">
            <div class="card-header p-primary bg-transparent">
              <h5 class="card-title m-0">Adjuntos</h5>
            </div>
            <div class="card-body">
              <div class="form-group mb-primary row align-items-center">
                <label class="col-sm-2 mb-sm-0">
                  <label>{{ $t("taxid") }}</label>
                </label>
                <div class="col-sm-8">
                  <a
                    :href="inputs.attach_ruc"
                    class="btn btn-primary"
                    target="_blank"
                  >
                    <app-icon name="file"></app-icon> Ver
                  </a>
                </div>
              </div>

              <div class="form-group mb-primary row align-items-center">
                <label class="col-sm-2 mb-sm-0">
                  <label>{{ $t("taxid_ci") }}</label>
                </label>
                <div class="col-sm-8">
                  <a
                    :href="inputs.attach_taxid"
                    class="btn btn-primary"
                    target="_blank"
                  >
                    <app-icon name="file"></app-icon> Ver
                  </a>
                </div>
              </div>

              <div class="form-group mb-primary row align-items-center">
                <label class="col-sm-2 mb-sm-0">
                  <label>{{ $t("legal_rep_attach") }}</label>
                </label>
                <div class="col-sm-8">
                  <a
                    :href="inputs.attach_legalrep"
                    class="btn btn-primary"
                    target="_blank"
                  >
                    <app-icon name="file"></app-icon> Ver
                  </a>
                </div>
              </div>

              <div
                class="form-group mb-primary row align-items-center"
                v-if="inputs.attach_agreement"
              >
                <label class="col-sm-2 mb-sm-0">
                  <label>{{ $t("agreement") }}</label>
                </label>
                <div class="col-sm-8">
                  <a
                    :href="inputs.attach_agreement"
                    class="btn btn-primary"
                    target="_blank"
                  >
                    <app-icon name="file"></app-icon> Ver
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!--
                    <fieldset class="form-group">

                        <div class="card card-with-shadow border-0 mb-primary">
                            <div class="card-header p-primary bg-transparent">
                                <h5 class="card-title m-0">Aprobación del Registro</h5>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Comentarios</label>
                                    <app-input type="textarea"
                                                v-model="inputs.comments"
                                                />
                                </div>
                            </div>
                        </div>

                    </fieldset> -->

          <!-- <div class="mt-5">
                        <button type="submit" class="btn btn-success mr-2" @click.prevent="submit(true)">
                            <i data-feather="check" class="pr-2"/>Aprobar
                        </button>
                        <button type="submit" class="btn btn-danger mr-2" @click.prevent="submit(false)">
                            <i data-feather="x" class="pr-2"/>Rechazar
                        </button>
                    </div> -->

          <div class="col-12">
            <label>Observaciones</label>
            <table class="table table-sm table-striped text-center">
              <thead>
                <tr>
                  <th scope="col">Usuario</th>
                  <th scope="col">Evento</th>
                  <th scope="col">Observacion</th>
                  <th scope="col">Fecha</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, index) in inputs.observations" :key="index">
                  <td>
                    {{ `${value.user.first_name} ${value.user.last_name}` }}
                  </td>
                  <td>{{ value.status.name }}</td>
                  <td>{{ value.observation }}</td>
                  <td>{{ value.created_at | dateFormat }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Activo</label>
              <app-input
                type="radio-buttons"
                :list="confirm"
                v-model="inputs.is_active"
              />
            </div>
          </div>
          <div class="col-12" v-if="inputs.is_active == 0">
            <div class="form-group">
              <label>Observación</label>
              <app-input
                type="textarea"
                :required="true"
                v-model="inputs.observation"
              />
            </div>
          </div>
          <div class="col-12 mt-3">
            <button
              type="submit"
              class="btn btn-primary"
              @click.prevent="submit"
            >
              {{ $t("save") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiUrl";

export default {
  name: "RegisterFormApproved",
  mixins: [FormMixin],
  props: {
    orgId: String,
    backUrl: {
      type: String,
      default: "/",
    },
  },
  data() {
    return {
      url: "",
      preloader: false,
      showCity: false,
      rucFile: "Seleccionar Archivo",
      taxidFile: "Seleccionar Archivo",
      legalRepFile: "Seleccionar Archivo",
      agreementFile: "Seleccionar Archivo",
      selectedSocietyType: "",
      inputs: {},
      kindOfSocietyLists: [
        { id: "private", value: "Sociedad Privada" },
        { id: "public", value: "Sociedad Pública" },
        { id: "other", value: "Otro" },
      ],
      countryLists: [],
      countryList: [{ id: "", value: "Seleccione País" }],
      provinceLists: [],
      provinceList: [{ id: "", value: "Seleccione Provincia" }],
      cantonLists: [],
      cantonList: [{ id: "", value: "Seleccione Canton" }],
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
    };
  },
  created() {
    this.getInfo();
    this.data();
  },
  filters: {
    dateFormat: function (value) {
      return value ? moment(value).format("YYYY-MM-DD HH:mm") : "";
    },
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit(approval) {
      if (approval) {
        this.inputs.is_approved = true;
      } else {
        this.inputs.is_approved = false;
      }
      this.inputs.id = this.orgId;
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.preloader = true;
      if (response.status == 200) {
        window.location = "/approved/oec";
      }
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getInfo() {
      this.preloader = true;
      let url = `${actions.COMMON_POLITICAL_DIVISION}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.countryLists = response.data.countries;
            this.countryList = [
              ...this.countryLists.filter((item) => {
                return item;
              }),
            ];
            this.provinceLists = response.data.provinces;
            this.provinceList = [
              ...this.provinceLists.filter((item) => {
                return item;
              }),
            ];
            this.cantonLists = response.data.cantons;
            this.cantonList = [
              ...this.cantonLists.filter((item) => {
                return item;
              }),
            ];
          }
        })
        .catch(({ error }) => {
          console.log("ERROR: ", error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    data() {
      this.preloader = true;
      let url = `${actions.USERS_REGISTER}/form/${this.orgId}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            const tmp = {};
            tmp.observations = response.data.organization.observations;
            tmp.company_name = response.data.organization.name;
            tmp.social_reason = response.data.organization.business_name;
            tmp.ruc = response.data.organization.taxid;
            tmp.society_type = response.data.organization.organization_type;
            tmp.email = response.data.organization.email;
            tmp.company_address = response.data.organization.address;
            tmp.phone = response.data.organization.phone;
            tmp.country_id = response.data.organization.country_id;
            tmp.province_id = response.data.organization.province_id;
            tmp.canton_id = response.data.organization.canton_id;
            tmp.city = response.data.organization.city;
            tmp.user_id = response.data.organization.user.id;
            tmp.first_name = response.data.organization.user.first_name;
            tmp.last_name = response.data.organization.user.last_name;
            tmp.email_legal_rep = response.data.organization.user.email;
            tmp.phone_extension = response.data.organization.phone_extension;
            tmp.taxid_legal_rep =
              response.data.organization.legal_representative_taxid;
            tmp.is_active = response.data.organization.is_active;
            tmp.username = response.data.organization.user.username;
            tmp.created_at = moment(String(response.data.organization.created_at)).format('YYYY-MM-DD HH:mm');
            for (
              let i = 0;
              i < response.data.organization.user.file.length;
              i++
            ) {
              if (response.data.organization.user.file[i].type === "ruc") {
                tmp.attach_ruc =
                  response.data.organization.user.file[i].full_url;
              }
              if (response.data.organization.user.file[i].type === "taxid") {
                tmp.attach_taxid =
                  response.data.organization.user.file[i].full_url;
              }
              if (response.data.organization.user.file[i].type === "legalrep") {
                tmp.attach_legalrep =
                  response.data.organization.user.file[i].full_url;
              }
              if (
                response.data.organization.user.file[i].type === "agreement"
              ) {
                tmp.attach_agreement =
                  response.data.organization.user.file[i].full_url;
              }
            }
            this.inputs = tmp;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
